var TableList = function () {

	this.init = function () {
		$(".tabs-btn").click(function () {
			$(".tabs-btn").removeClass('current-tab');
			$(this).toggleClass('current-tab');
			$('.tabs-btn').css('pointer-events', 'none');

			setTimeout(function () {
				$('.tabs-btn').css('pointer-events', 'auto');
			}, 300);
		});
	}

	return this.init();
}

$('.tabelas').hide();
$('.tabelas:first').show();

$('#filter-select').on('change', function(){
	$('.tabelas').hide();
	$("#"+$(this).val()).fadeIn(700).show(700);
});

$('.relatorios').hide();
$('.pagnationTab').hide();
$('.relatorios:first').show();
$('.pagnationTab:first').show();
$('.previous').hide();

$('#filter-select').on('change', function(){
	$('.relatorios').hide();
	$('.pagnationTab').hide();
	$('.pages-holder a').removeClass('current');
	$('.pages-holder a:first-child').addClass('current');
	$('.tab-relatorios').hide();
	$('.previous').hide();
	$('.tab-12').show();
	$('.'+$(this).val()).show();
});

$('.tab-relatorios').hide();
$('.tab-12').show();

$('.pagination .next').click(function(){
	let page = parseInt($('.pages-holder .current').attr('data-page')) + 1;
	if (page != 0){
		let numPage = page * 12;
		$('.pages-holder .current').next().addClass('current');
		$('.pages-holder .current').prev().removeClass('current');
		let ultimo = $('.'+$(this).attr('data-tab')+' .pages-holder a').last().attr('data-page');
		if(page == ultimo){
			$(this).hide();
		}
		$('.previous').show();
		$('.tab-relatorios').hide();
		$('.tab-'+numPage).show();
	}
});

$('.pagination .previous').click(function(){
	let page = parseInt($('.pages-holder .current').attr('data-page')) - 1;
	if (page != 0){
		let numPage = page * 12;
		$('.pages-holder .current').prev().addClass('current');
		$('.pages-holder .current').next().removeClass('current');
		let primeiro = $('.'+$(this).attr('data-tab')+' .pages-holder a').first().attr('data-page');
		if(page == primeiro){
			$(this).hide();
		}
		$('.next').show();
		$('.tab-relatorios').hide();
		$('.tab-'+numPage).show();
	}
});

$('.pages-holder a').click(function(e){
	e.preventDefault();
	$('.pages-holder a').removeClass('current');
	$(this).addClass('current');
	let numPage = $(this).attr('data-page') * 12;
	$('.tab-relatorios').hide();
	$('.tab-12').hide();
	$('.tab-'+numPage).show();
});
